<template>
    <div class="white_bg">
        <div class="inner">

            <div class="jobList hiddenScrollbar" style="overflow: auto">
                <div class="jobItem roundBorder4" style="background: #F5F5F5;" v-for="(dataItem, i) in dataList"
                     :key="i">
                    <div class="padding8">
                        <div class="clearfix font14r">
                            <div class="fl">
                                <span v-if="dataItem.name">{{ dataItem.name }}</span>
                                <span>
                                    &nbsp;|&nbsp; {{ dataItem ? dataItem.salaryMin || "面议" : "面议" }}<span v-if="dataItem.salaryMin">千</span>
                                </span>
                                <span v-if="dataItem.salaryMax && dataItem.salaryMin">&nbsp;-&nbsp;{{ dataItem ? dataItem.salaryMax || "面议" : "面议" }}<span v-if="dataItem.salaryMax">千</span>
                                </span>
                                <span v-if="dataItem.salaryMin && dataItem.salaryMax">/月</span>
                                <!-- <span v-if="dataItem.salaryMin">  {{ dataItem.salaryMin }} 千</span>
                                <span v-if="dataItem.salaryMax">- {{ dataItem.salaryMax }} 千/月</span> -->
                            </div>
                            <div class="fr">
                                <i class="icon lightgreyDeleteIcon" style="width: 14px; height: 14px;"
                                   @click="removeDataItem(dataItem)"></i>
                            </div>
                        </div>
                        <div class="marginT8 font12r" style="color: #8994A9">
                            岗位要求：{{ dataItem.information }}
                        </div>
                    </div>
                </div>
            </div>

            <div>
               <router-link class="block button yellowButton" to="/myPark/job/edit" style="padding: 0;
               line-height: 42px; height: 42px; border-radius: 20px;">添加职位
               </router-link>
                <!-- <span class="block button yellowButton" @click="developing" style="padding: 0;
                    line-height: 42px; height: 42px; border-radius: 20px;">添加职位
                </span> -->
            </div>
        </div>

    </div>
</template>

<script>
import generalCmpPart from '@comp/part/generalCmpPart';

// config
import appConfig from '../../../appConfig';

// util
import numberHelper from "@util/numberHelper";
import appHelper from "@util/appHelper";

const config = {
    apiConfig: {
        list: {
            url: appConfig.apiBaseUrl + 'portal/recruit/jobs/list',
            dataPath: 'data.records',
            totalPagePath: 'data.pages'
        },
        remove: {
            url: appConfig.apiBaseUrl + 'portal/recruit/jobs/remove',
            method: 'DELETE'
        }
    },
    demoNameList: [
        '幼儿教师',
        '小班辅导员',
        '教务老师'
    ]
};

export default {
    name: "jobList",
    extends: generalCmpPart,
    components: {},
    data() {
        return {
            apiConfig: config.apiConfig,
            enableDataList: true,
            autoLoadDataList: appConfig.mode != 'demo',
        }
    },
    methods: {
        onRemoveDataItem() {
            this.reloadDataList();
        },
        developing() {
            appHelper.showHint('功能更新中');
        },
    }
}
</script>

<style lang="scss" scoped>
.jobItem {
    margin-bottom: 12px;
}
</style>
